import { Template, TemplateTypes } from 'sections/onsite-campaigns/types';
import { DomainRule, IsInFlowService } from '../../types';

export interface SendEmailRequiredWithSMBRuleDto {
  displayWebsiteContentTemplate: Template;
  isInFlowService: IsInFlowService;
}

export const SendEmailRequiredWithSMBRuleKey = 'sendEmailRequiredWithSMB';

export const SendEmailRequiredWithSMBRule = (dto: SendEmailRequiredWithSMBRuleDto): DomainRule => {
  const isSendEmailInFlow = !!dto.isInFlowService.isSendEmailInFlow();

  if (dto.displayWebsiteContentTemplate?.type === TemplateTypes.SendMyBasket && !isSendEmailInFlow) {
    return {
      result: 'fail',
      ruleKey: SendEmailRequiredWithSMBRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
